module.exports = __webpack_public_path__ + "static/img/1.40323e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/4/1.png
// module id = mAM3
// module chunks = 0